import DateTokens from './DateFormatToken'

const {
  YYYYMMDDWithSlash,
  YYYYMMDDWithDash,
  MMDDYYWithSlash,
  MMDDYYWithDash,
  MMDDYYYYWithSlash,
  MMDDYYYYWithDash,
  DDMMYYYYWithSlash,
  DDMMYYYYWithDash,
  DDMMYYWithSlash,
  DDMMYYWithDash,
} = DateTokens

export const AusDateFormats = [
  DDMMYYWithSlash,
  DDMMYYWithDash,
  DDMMYYYYWithSlash,
  DDMMYYYYWithDash,
  YYYYMMDDWithDash,
  YYYYMMDDWithSlash,
]

export const USADateFormats = [
  MMDDYYWithSlash,
  MMDDYYWithDash,
  MMDDYYYYWithSlash,
  MMDDYYYYWithDash,
  YYYYMMDDWithDash,
  YYYYMMDDWithSlash,
]
